import { render, staticRenderFns } from "./ChildPage.vue?vue&type=template&id=a3085700&scoped=true&"
import script from "./ChildPage.vue?vue&type=script&lang=js&"
export * from "./ChildPage.vue?vue&type=script&lang=js&"
import style0 from "./ChildPage.vue?vue&type=style&index=0&id=a3085700&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3085700",
  null
  
)

export default component.exports